(ns journal-app-client.modals.tag-search
  (:require [journal-app-client.components.button :as button]
            [journal-app-client.components.input :as input]
            [journal-app-client.utils.common :as common]
            [journal-app-client.utils.formatting :as fmt]
            [journal-app-client.components.tree :as tree]
            [clojure.string :as s]
            [re-frame.core :as rf]
            [journal-app-client.components.modal :as m]
            [journal-app-client.utils.react :refer [use-state]]))

(defn modal-list-fn [id props]
  (let [tags (:tags props)
        tag-set (:set tags)
        tag-data (:data props)
        tag-data-path (or (:data-path tags) [:information :name])
        observed-state-path (:observed-state-path tags)
        observed-state (when observed-state-path nil)
        [search set-search] (use-state "")
        [tag-set set-tag-set] (use-state tag-set)
        filtered-tag-data (common/sort-by-numbers-in-string
                            (fn [tag]
                              (or (when observed-state
                                    (get-in (get observed-state (first tag)) observed-state-path))
                                  (get-in (second tag) tag-data-path "Unnamed")))
                            (filter #(or (s/includes? (fmt/lower-case
                                                        (or (when observed-state
                                                              (get-in (get observed-state (first %)) observed-state-path))
                                                            (get-in (second %) tag-data-path "Unnamed")))
                                                      (fmt/lower-case search))
                                         (= "" search)) tag-data))]
    [:<>
     [m/body
      [:div.box
       {:style {:position   "sticky"
                :top        "0"
                :z-index    "2"
                :min-height "8rem"}}
       [input/input
        {:placeholder  (:text tags)
         :auto-focus   true
         :value        search
         :on-enter-key #(set-tag-set (if (contains? tag-set (first (first filtered-tag-data)))
                                       (disj tag-set (first (first filtered-tag-data)))
                                       (conj tag-set (first (first filtered-tag-data)))))
         :on-change    #(set-search (-> % .-target .-value))}]
       (into
         [:div.field.is-grouped.is-grouped-multiline
          {:style {:margin-top "1rem"}}]
         (map
           (fn [id]
             [:div.control
              [:div.tags.has-addons.fade-in
               [:span.tag
                (or (when observed-state
                      (get-in (get observed-state id) observed-state-path))
                    (get-in tag-data (into [id] tag-data-path) id))]
               [:a.is-delete.tag.is-danger
                {:on-click #(set-tag-set (disj tag-set id))}]]])
           tag-set))]
      (into
        [:div.box
         (when (empty? tag-data)
           [:p.subtitle
            {:style {:color "var(--warning)"}}
            "No data. Please create more to be able to add them."])]
        (map-indexed
          (fn [index [tag-id tag]]
            [button/button
             {:key      (str tag-id)
              :class    (str (if (contains? tag-set tag-id)
                               " is-success "
                               " is-outlined ")
                             "is-fullwidth fade-in")
              :style    {:margin (when (= index (dec (count filtered-tag-data))) "0")}
              :on-click #(set-tag-set (if (contains? tag-set tag-id)
                                        (disj tag-set tag-id)
                                        (conj tag-set tag-id)))}
             [:span (or (when observed-state
                          (get-in (get observed-state tag-id) observed-state-path))
                        (get-in tag tag-data-path "Unnamed"))]])
          filtered-tag-data))]
     [m/footer {:style {:flex-wrap "wrap"}}
      [button/button
       {:aria-label "Close"
        :class      "is-outlined"
        :style      {:flex   1
                     :margin "0.25rem"}
        :on-click   #(rf/dispatch [:close-modal id])}
       [:span "Cancel"]]
      [button/button
       {:class    " is-outlined is-success "
        :style    {:flex   1
                   :margin "0.25rem"}
        :on-click (fn []
                    (when (fn? (:on-click props))
                      ((:on-click props) tag-set))
                    (rf/dispatch [:close-modal id]))}
       [:span "Confirm"]]]]))

(defn modal-tree-fn [id props]
  (let [tags (:tags props)
        tag-set (:set tags)
        tag-data (:data props)
        tree-data (:tree-data props)
        tag-data-path (or (:data-path tags) [:information :name])
        observed-state-path (:observed-state-path tags)
        observed-state (when observed-state-path nil)
        [search set-search] (use-state "")
        [tag-set set-tag-set] (use-state tag-set)
        [state set-state] (use-state {:open tag-data
                                      :selected-ids tag-set})
        filtered-tag-data (common/sort-by-numbers-in-string
                            (fn [tag]
                              (or (when observed-state
                                    (get-in (get observed-state (first tag)) observed-state-path))
                                  (get-in (second tag) tag-data-path "Unnamed")))
                            (filter #(or (s/includes? (fmt/lower-case
                                                        (or (when observed-state
                                                              (get-in (get observed-state (first %)) observed-state-path))
                                                            (get-in (second %) tag-data-path "Unnamed")))
                                                      (fmt/lower-case search))
                                         (= "" search)) tag-data))]
    [:<>
     [m/body
      [:div.box
       {:style {:position   "sticky"
                :top        "0"
                :z-index    "2"
                :min-height "8rem"}}
       [input/input
        {:placeholder  (:text tags)
         :auto-focus   true
         :value        search
         :on-enter-key (fn []
                         (let [tag-id (first (first filtered-tag-data))]
                           (set-tag-set (if (contains? tag-set tag-id)
                                          (disj tag-set tag-id)
                                          (conj tag-set tag-id)))
                           (set-state (assoc state :selected-ids
                                             (if (contains? (:selected-ids state) tag-id)
                                               (disj (:selected-ids state) tag-id)
                                               (conj (:selected-ids state) tag-id))))))
         :on-change    #(set-search (-> % .-target .-value))}]
       (into
         [:div.field.is-grouped.is-grouped-multiline
          {:style {:margin-top "1rem"}}]
         (map
           (fn [id]
             [:div.control
              [:div.tags.has-addons.fade-in
               [:span.tag
                (or (when observed-state
                      (get-in (get observed-state id) observed-state-path))
                    (get-in tag-data (into [id] tag-data-path) id))]
               [:a.is-delete.tag.is-danger
                {:on-click (fn []
                             (set-tag-set (disj tag-set id))
                             (set-state (assoc state :selected-ids (disj tag-set id))))}]]])
           tag-set))]
      [:div.box
       (when (empty? tag-data)
         [:p.subtitle
          {:style {:color "var(--warning)"}}
          "No data. Please create more to be able to add them."])
       [:f> tree/tree-indented
        (assoc props :search (fmt/lower-case search)
               :type (:type tags)
               :children tree-data
               :use-state [state set-state]
               :on-click (fn [{:keys [parent]}]
                           (let [data-id (first parent)]
                             (set-tag-set (if (contains? tag-set data-id)
                                            (disj tag-set data-id)
                                            (conj tag-set data-id))))))]]]
     [m/footer {:style {:flex-wrap  "wrap"
                        :gap "0.5rem"}}
      [button/button
       {:aria-label "Close"
        :class      "is-outlined"
        :style      {:flex   1}
        :on-click   #(rf/dispatch [:close-modal id])}
       [:span "Cancel"]]
      [button/button
       {:class    " is-outlined is-success "
        :style    {:flex   1}
        :on-click (fn []
                    (when (fn? (:on-click props))
                      ((:on-click props) tag-set))
                    (rf/dispatch [:close-modal id]))}
       [:span "Confirm"]]]]))

(defn main [id props]
  (let [tags (:tags props)
        data (when (:subscribe-data-path tags) @(rf/subscribe (:subscribe-data-path tags)))
        tree-data (when (:subscribe-tree-data-path tags) @(rf/subscribe (:subscribe-tree-data-path tags)))]
    (if tree-data
      [:f> modal-tree-fn id (assoc props :data data :tree-data tree-data)]
      [:f> modal-list-fn id (assoc props :data data)])))